import {
  faCheckCircle,
  faFolderOpen,
  faLockOpen,
  faPaperPlane,
  faSearch,
  faSeedling,
  faWarning,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

export const dados_status = [
  {
    nome: 'ABERTA',
    cod: 1,
    disable: false,
  },
  {
    nome: 'LIBERADA',
    cod: 2,
    disable: false,
    hidden: process.env.NODE_ENV === 'production',
  },
  {
    nome: 'COLETADA',
    cod: 3,
    disable: false,
  },
  {
    nome: 'ENVIADO PARA ANÁLISE',
    cod: 4,
    disable: false,
  },
  {
    nome: 'EM ANÁLISE',
    cod: 5,
    disable: false,
  },
  {
    nome: 'ANALISADA',
    cod: 9,
    disable: false,
    // hidden: process.env.NODE_ENV === "production",
  },
]

export const statusIcones = {
  1: faFolderOpen,
  2: faLockOpen,
  3: faSeedling,
  4: faPaperPlane,
  5: faSearch,
  7: faWarning,
  8: faXmark,
  9: faCheckCircle,
}

export const statusBackground = {
  1: '#E6FFFB',
  2: '#FFF7E6',
  3: '#F0F5FF',
  4: '#F9F0FF',
  5: '#E6F4FF',
  7: '#FFFEED',
  8: '#FDEFEF',
  9: '#F6FFED',
}

export const statusBorder = {
  1: '#87E8DE',
  2: '#D46B08',
  3: '#ADC6FF',
  4: '#D3ADF7',
  5: '#91CAFF',
  7: '#EFC82D',
  8: '#FF4D4F',
  9: '#76C515',
}

export const statusColor = {
  1: '#08979C',
  2: '#D46B08',
  3: '#1D39C4',
  4: '#531DAB',
  5: '#1677FF',
  7: '#F8CE26',
  8: '#FF4D4F',
  9: '#76C515',
}
